import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// Custom Components
import { AccountLink } from "../Common Modules/Common Modules";
import Loader from "../Loader/Loader";
import Custom_Popup from "../Common Modules/Custom_Popup";
import { encryptData } from "../CRYPTO/crypto";
import { checkFillAllTheDetailsDataAPI } from "../../api";
import axios from "axios";
import "./Login.css";
import Heading from "../Heading/Heading";
import { Button, Modal } from "react-bootstrap";
import Maintenance from "./Maintenance";

const Login = ({ onLogin }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [VarifiedSuccess, setVarifiedSuccess] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    // Google reCAPTCHA Site Key (Replace with your actual site key)
    const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "YOUR_SITE_KEY_HERE";

    // Load reCAPTCHA Script
    useEffect(() => {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
        script.async = true;
        script.defer = true;
        script.onerror = () => {
            toast.error("Failed to load reCAPTCHA. Please check your internet connection.");
        };
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, [RECAPTCHA_SITE_KEY]);

    // Check URL for account verification success
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const account_verified = queryParams.get("account_verified");
        if (account_verified === "true") {
            setVarifiedSuccess(true);
        }
    }, [location.search]);

    const closeVerifiedModal = () => {
        setVarifiedSuccess(false);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleForgotPassword = (e) => {
        e.preventDefault();
        navigate("/user/forgot_password");
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        setEmailError(value ? !validateEmail(value) : false);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleLogin();
        }
    };

    const handleCheckForDetails = async (token) => {
        try {
            const response = await checkFillAllTheDetailsDataAPI(token);
            console.log("ressppooince", response)
            if (
                response?.data?.response?.success_msg === "Proceed to Dashboard" &&
                response?.data?.response?.response === true
            ) {
                const userData = response.data.response.data;
                localStorage.setItem("userId", userData.userId);
                localStorage.setItem("userName", userData.user_name);
                localStorage.setItem("profileDetailsFilled", true);
                toast.success(`Login successful. Welcome, ${userData.user_name}!`);
                navigate("/user/dashboard");
                onLogin && onLogin();
            } else {
                const userData = response.data.response?.data;
                localStorage.setItem("userId", userData?.userId);
                localStorage.setItem("userName", userData?.user_name);
                localStorage.setItem("profileDetailsFilled", false);
                toast.warning(`Complete your profile first, ${userData?.user_name}!`);
                navigate("/user/complete_profile");
            }
        } catch (error) {
            console.error("Error checking for details:", error);
            toast.error("An error occurred while checking for profile details.");
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        console.log("Login clicked");
        // Validation
        if (!email || !validateEmail(email)) {
            setEmailError(true);
            toast.error("Please enter a valid email address.");
            document.getElementById("email").focus();
            return;
        }
        if (!password) {
            toast.error("Please enter your password.");
            document.getElementById("password").focus();
            return;
        }

        setIsLoading(true);

        try {
            //   // Execute reCAPTCHA and get token
            //   const recaptchaToken = await window.grecaptcha.execute(RECAPTCHA_SITE_KEY, {
            //     action: "login",
            //   });

            const formData = new FormData();
            formData.append("email", email);
            formData.append("password", password);
            // formData.append("recaptcha_token", recaptchaToken); // Send token to backend

            const loginResponse = await axios.post(
                process.env.REACT_APP_AQATO_AGENT_APPLICANT_PORTAL_BASE_API_URL + "/user/user_login_check",
                formData
            );

            const responseData = loginResponse?.data?.response;

            if (responseData && responseData.response === true) {
                const token = responseData.token;
                const encryptedToken = encryptData(token);

                localStorage.clear();
                localStorage.setItem("account_type", responseData.data.account_type);
                localStorage.setItem("isLoggedIn", true);
                localStorage.setItem("encryptedToken", encryptedToken);
                localStorage.setItem("userId", responseData.data.user_id);

                if (responseData.data.navigator_to_dashboard) {
                    // toast.success("Login successful!");
                    navigate("/user/dashboard");
                } else {
                    toast.warning("Please complete your profile.");
                    navigate("/user/complete_profile");
                }

                handleCheckForDetails(token);
            } else {
                const errorMsg = responseData?.error_msg || "Invalid credentials.";
                toast.error(errorMsg.includes("Invalid") ? "Invalid email or password." : errorMsg);
            }
        } catch (error) {
            console.error("Login failed:", error);
            toast.error("An error occurred during login. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Heading text="Welcome to the Trade Skills Assessment Online Portal" />

            <div className="login-page-wrapper container-fluid pb-6">
                <div className="login-flex-container">
                    {/* Left Side Images */}
                    <div className="image-section">
                        <div className="image_parent_container">
                            <div className="image_container image_shift">
                                <img
                                    src="http://api.aqato.com.au/public/app_files/login/industry.jpg"
                                    alt="decoration"
                                    className="image_box"
                                />
                                <img
                                    src="http://api.aqato.com.au/public/app_files/login/fd088efe776a4b972f02013429be4f1464a03b60.jpg"
                                    alt="decoration"
                                    className="image_box"
                                />
                            </div>

                            <div className="image_container top_shift">
                                <img
                                    src="http://api.aqato.com.au/public/app_files/login/f5ff72b2969cfbe9c041eeee76e9005fe8cc0fbe.jpg"
                                    alt="decoration"
                                    className="image_box"
                                />
                                <img
                                    src="http://api.aqato.com.au/public/app_files/login/ecc5d97c13ac710b77addcb3871bdd2270a006cf.jpg"
                                    alt="decoration"
                                    className="image_box"
                                />
                            </div>

                            <div className="image_container image_shift">
                                <img
                                    src="http://api.aqato.com.au/public/app_files/login/474831b5be9e7b004868342d4b1fa2967b7ee391.jpg"
                                    alt="decoration"
                                    className="image_box"
                                />
                                <img
                                    src="http://api.aqato.com.au/public/app_files/login/fd088efe776a4b972f02013429be4f1464a03b602322.jpg"
                                    alt="decoration"
                                    className="image_box"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Right Side Form */}
                    <div className="form-section">
                        <div className="form_container">
                            <div className="inner_form_container">
                                <form
                                    className="login_form"
                                    onSubmit={handleLogin}
                                    onKeyDown={handleKeyDown}
                                >
                                    <h5 className="form_heading">Applicant / Agent Login</h5>

                                    <div className="form_inputs">
                                        {/* Email Field */}
                                        <div className="form_label_class">
                                            <label htmlFor="email">
                                                <b>Email address</b>
                                                <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                className={`form_input ${emailError ? "error-border" : ""}`}
                                                value={email}
                                                onChange={handleEmailChange}
                                                placeholder="Enter your email address"
                                            />
                                            {emailError && (
                                                <div className="error-message">
                                                    Please enter a valid email address.
                                                </div>
                                            )}
                                        </div>

                                        {/* Password Field */}
                                        <div className="form_label_class">
                                            <label htmlFor="password">
                                                <b>Password</b>
                                                <span className="text-danger">*</span>
                                            </label>
                                            <div className="password-input-wrapper">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    id="password"
                                                    name="password"
                                                    className="form_input"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    placeholder="Enter your password"
                                                />
                                                <span
                                                    className="password-toggle-icon"
                                                    onClick={togglePasswordVisibility}
                                                >
                                                    <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <a
                                        href="/user/forgot_password"
                                        className="forgot_password_link"
                                        onClick={handleForgotPassword}
                                    >
                                        Forgot password?
                                    </a>

                                    <button type="submit" className="submit_btn" disabled={isLoading}>
                                        {isLoading ? (
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                            ></span>
                                        ) : (
                                            <>
                                                Login{" "}
                                                <span>
                                                    <i className="bi bi-arrow-right"></i>
                                                </span>
                                            </>
                                        )}
                                    </button>

                                    <div className="centered-content">
                                        <AccountLink
                                            promptText="Don't have an account?"
                                            linkText="Create an account"
                                            linkUrl="/user/create_new_account"
                                        />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* Modal for Verified Success */}
            
      <Modal
        show={VarifiedSuccess}
        onHide={closeVerifiedModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#055837" }}>
            Account Verified !
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your account has been successfully verified. Please log in to
          continue.
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="light"
            onClick={closeVerifiedModal}
            // className="w-50"
            style={{
              maxWidth: "100px",
              backgroundColor: "#ffcc01",
              color: "#055837",
              transition: "transform 0.2s",
              fontSize: "17px",
            }}
            onMouseEnter={(e) => (e.target.style.transform = "scale(1.02)")}
            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
          >
            Okay
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <Maintenance /> */}


        </>
    );

};

export default Login;